// extracted by mini-css-extract-plugin
module.exports = {"label":"_02712f2b3b--label--XI5A0","pros":"_02712f2b3b--pros--QaXPQ","cons":"_02712f2b3b--cons--I13Sb"};